import { useCallback } from 'react';
import { useRequest } from './useRequest';
import { Project, ProjectCreate } from '../types/project';

export function useProject() {
  const listRequest = useRequest<Project[]>();
  const createRequest = useRequest<Project>();
  const updateRequest = useRequest<Project>();
  const deleteRequest = useRequest<void>();

  const fetchProjects = useCallback(() => {
    const url = `${process.env.REACT_APP_API_BASE_URL}/api/projetos`;
    listRequest.execute(url);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const createProject = useCallback(async (data: ProjectCreate) => {
    await createRequest.execute(`${process.env.REACT_APP_API_BASE_URL}/api/projetos`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateProject = useCallback(async (id: number, data: Partial<ProjectCreate>) => {
    await updateRequest.execute(`${process.env.REACT_APP_API_BASE_URL}/api/projetos/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const deleteProject = useCallback(async (id: number) => {
    await deleteRequest.execute(`${process.env.REACT_APP_API_BASE_URL}/api/projetos/${id}`, {
      method: 'DELETE',
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    projects: listRequest.data || [],
    listLoading: listRequest.loading,
    listError: listRequest.error,
    saveLoading: createRequest.loading || updateRequest.loading,
    saveError: createRequest.error || updateRequest.error,
    deleteLoading: deleteRequest.loading,
    deleteError: deleteRequest.error,
    fetchProjects,
    createProject,
    updateProject,
    deleteProject,
  };
}